export class dataStore {
    constructor(url , query){
        this.axios = axios;
        this.url = url ; 
        this.query = query ;
        this.dataCon;
    }


    get(){
        if( process.env.NODE_ENV === "production") {
            return this.axios.get(this.url);
        }
            return this.axios.get(`${this.url}${this.query}`);
    }


    post(){

    }

}


// WEBPACK FOOTER //
// ./modules/services/_datastore.js